import { render, staticRenderFns } from "./SharingEntryInherited.vue?vue&type=template&id=23251e4a&scoped=true&"
import script from "./SharingEntryInherited.vue?vue&type=script&lang=js&"
export * from "./SharingEntryInherited.vue?vue&type=script&lang=js&"
import style0 from "./SharingEntryInherited.vue?vue&type=style&index=0&id=23251e4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23251e4a",
  null
  
)

export default component.exports